import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { usePersonalDetails } from 'components/my-profile/usePersonalDetails';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PostboxUi } from './ui';
import { useContractPostbox } from './usePostbox';
import { MyDocumentsLoadingPlaceholder, Notification, NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Contract } from 'cpes-common';
import { PostboxLocationState } from './PostboxLocationState';

const PostboxWithHandlers = withLoadingAndNoConnectionHandler(PostboxUi);

export const Postbox: React.FC<{ contractId: string; contracts: Contract[] } & PostboxLocationState> = ({
    contractId,
    contracts,
    filterToInvoices,
    timeframeFilter,
}) => {
    const { t } = useTranslation('postbox');
    const {
        data: postboxDocuments,
        isLoading: isLoadingPostbox,
        loadingError: loadingErrorPostbox,
    } = useContractPostbox(contractId);

    const {
        data: personalDetails,
        isLoading: isLoadingPersonalDetails,
        loadingError: loadingErrorPersonalDetails,
    } = usePersonalDetails();

    const isLoading = isLoadingPostbox || isLoadingPersonalDetails;
    const postboxApiOrContractsApiError = !!loadingErrorPostbox;

    const hasInvoiceConsent =
        personalDetails?.invoiceConsent?.signUp !== undefined ? personalDetails?.invoiceConsent?.signUp : false;

    return (
        <>
            {!postboxApiOrContractsApiError && (
                <PostboxWithHandlers
                    isLoading={isLoading}
                    postboxDocuments={postboxDocuments}
                    contracts={contracts}
                    hasInvoiceConsent={hasInvoiceConsent}
                    hasError={false}
                    hasSignUpCheckError={!!loadingErrorPersonalDetails}
                    loadingPlaceholder={<MyDocumentsLoadingPlaceholder />}
                    initialFilterToInvoices={filterToInvoices}
                    initialTimeframeFilter={timeframeFilter}
                />
            )}
            {postboxApiOrContractsApiError && isLoading && (
                <Notification testId="PostboxApiOrContractsApiError" status={NotificationStatus.error}>
                    {t('table.errors.api-not-available')}
                </Notification>
            )}
        </>
    );
};
